// App.jsx
import React, { useState, useMemo } from "react";
import "./scss/App.scss";
import Home from "./Home";
import Quiz from "./Quiz";

// A simple Thank You view
function ThankYou({ firstName, onRestart }) {
  return (
    <section className="thankyou section" style={{ backgroundImage: "url(https://s3.us-east-1.amazonaws.com/cdn.fanduel.com/mlb-sweepstakes/images/thankyou-bg.jpg)" }}>
      <div className="grid-container">
        <div className="grid-x grid-padding-x">
          <div className="small-12 small-offset-0 medium-10 medium-offset-1 large-8 large-offset-2 cell">
            <h2 className="thankyou__h2">Thanks for taking the quiz!</h2>
            <p className="thankyou__p">If you have a FanDuel account, you’re now officially entered for a chance to win NHL Shop gift code.</p>
            <p className="thankyou__p">Want to learn more about responsible gaming? Visit <a href="https://www.fanduel.com/playwithaplan" target="_blank" rel="noopener noreferrer">FanDuel.com/playwithaplan</a> or <a href="https://playsmartfromthestart.org/" target="_blank" rel="noopener noreferrer">PlaySmartFromTheStart.org</a> for tips, tools, and resources.</p>
            <hr/>
            <p className="thankyou__disclaimer"><span>Gambling Problem? Call 1-800-GAMBLER or 1-800-MY-RESET. Call 1-888-789-7777 or visit ccpg.org/chat (CT). Hope is here. GamblingHelpLineMA.org or call (800) 327-5050 for 24/7 support (MA). Visit www.mdgamblinghelp.org (MD). Call 1-877-8HOPE-NY or text HOPENY (467369) (NY).</span><br/>21+ (18+ D.C., KY, & WY) and present in select states (for KS, in affiliation with Kansas Star Casino). No purchase necessary. Limit 2 entries. Restrictions apply. See full terms including methods of entry at sportsbook.fanduel.com. Call 1-877-770-7867 (LA).</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function App() {
  // current view: "home" | "quiz" | "thankyou"
  const [view, setView] = useState("home");

  // participant data captured on Home
  const [participant, setParticipant] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    dob: "",
  });

  // quiz questions
  const questions = useMemo(
    () => [
      {
        id: 1,
        prompt: "Slapshot Stats: What does it mean when a team has -150 odds?",
        options: [
          "a. You win $150 for every $100 wagered ",
          "b. You need to bet $150 to win $100 ",
          "c. The team is the underdog ",
          "d. It's an even bet ",
        ],
        answerIndex: 1,
        correctAnswer: "B",
        explanation: "Negative odds mean you're betting on the favorite. -150 means you need to wager $150 to win $100 profit. "
      },
      {
        id: 2,
        prompt: "League Origins: When was the National Hockey League (NHL) founded?",
        options: [
          "a. 1893 ",
          "b. 1917  ",
          "c. 1926  ",
          "d. 1942  ",
        ],
        answerIndex: 1,
        correctAnswer: "B",
        explanation: "The NHL was founded on November 26, 1917, in Montreal, Quebec, starting with just four teams. "
      },
      {
        id: 3,
        prompt: "Overtime Odds: What does a \"puck line\" of -1.5 mean? ",
        options: [
          "a. The favored team must win by 2+ goals to cover ",
          "b. The underdog can lose by 1 goal and still cover ",
          "c. It's similar to a point spread in other sports ",
          "d. All of the above ",
        ],
        answerIndex: 3,
        correctAnswer: "D",
        explanation: "A puck line of -1.5 means the favored team must win by 2 or more goals. The underdog covers if they win or lose by only 1 goal. "
      },
      {
        id: 4,
        prompt: "Stanley Cup Stats: Which team has won the most Stanley Cup Championships? ",
        options: [
          "a. Toronto Maple Leafs  ",
          "b. Montreal Canadiens  ",
          "c. Detroit Red Wings  ",
          "d. Boston Bruins ",
        ],
        answerIndex: 1,
        correctAnswer: "B",
        explanation: "Explanation: The Montreal Canadiens have won 24 Stanley Cups, more than any other NHL franchise. "
      },
      {
        id: 5,
        prompt: "Penalty Kill: What's a warning sign that gambling may be becoming a problem?",
        options: [
          "a. Betting more than you can afford to lose ",
          "b. Chasing losses with bigger bets ",
          "c. Gambling affecting your relationships or work ",
          "d. All of the above ",
        ],
        answerIndex: 3,
        correctAnswer: "D",
        explanation: "All of these are warning signs. If you notice them, use FanDuel's responsible gaming tools or reach out for support. Remember, always play with a plan. "
      },
      {
        id: 6,
        prompt: "Power Play Perception: You win two bets in a row and feel like you \"can't lose.\" What is this called? ",
        options: [
          "a. Expert intuition ",
          "b. The hot hand fallacy ",
          "c. Streak logic ",
          "d. Winning formula ",
        ],
        answerIndex: 1,
        correctAnswer: "B",
        explanation: "\"on fire\" and can't lose. Each bet is independent—past wins don't guarantee future success."
      },
       {
        id: 7,
        prompt: "Icing Insight: What responsible gaming tool lets you set a maximum amount you can deposit over a specific time period? ",
        options: [
          "a. Wager limits ",
          "b. Time limits  ",
          "c. Deposit limits  ",
          "d. My Spend  ",
        ],
        answerIndex: 2,
        correctAnswer: "C",
        explanation: "Deposit limits help you control how much money you can add to your account over a day, week, or month—keeping your spending in check. "
      },
    ],
    []
  );

  const handleStartQuiz = (formValues) => {
    setParticipant(formValues);
    setView("quiz");
  };

  const SHEETS_WEBAPP_URL = "https://script.google.com/macros/s/AKfycbyJrPSNUorsNC8FQXuwj4dMRS88hhDZ13kf9rEg_L06jMImDiOEm87MZoHt0cjmXMHnNg/exec";

  const handleQuizComplete = async (results) => {
    // results is expected to look like: { total, answers }
    const payload = {
      ...participant, // firstname, lastname, email, phone, dob
      results,        // object: { total, answers }
    };

    try {
      const res = await fetch(SHEETS_WEBAPP_URL, {
        method: "POST",
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify(payload),
      });

      // Optional: basic response handling
      if (!res.ok) {
        const text = await res.text();
        console.error("Sheets error:", res.status, text);
      } else {
        const data = await res.json().catch(() => ({}));
        console.log("Sheets OK:", data);
      }
    } catch (err) {
      console.error("Network error sending to Google Sheets", err);
    } finally {
      // proceed to thank-you view regardless of network success
      setView("thankyou");
    }
  };

  const handleRestart = () => {
    setView("home");
  };

  return (
    <div className="app">
      <main className="main">
        {view === "home" && (
          <Home
            onStartQuiz={handleStartQuiz}
            initialValues={participant}
          />
        )}

        {view === "quiz" && (
          <Quiz
            questions={questions}
            participant={participant}
            onComplete={handleQuizComplete}
            onExit={() => setView("home")}
          />
        )}

        {view === "thankyou" && (
          <ThankYou
            firstName={participant.firstname}
            onRestart={handleRestart}
          />
        )}
      </main>
    </div>
  );
}
